import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-native-header',
  standalone:false,
  templateUrl: './app-native-header.component.html',
  styleUrls: ['./app-native-header.component.scss']
})
export class AppNativeHeaderComponent {
  @Input() pageTitle!: string;
  @Output() onCancel = new EventEmitter<void>();

  cancel() {
    this.onCancel.emit();
  }
}